import React, { useEffect, useState } from "react";
import { Medicalhistoycategories } from "../../../AgencyFlow/AgencyScreens/Patientinfoeditscreens/Historydata";
import { FetchMedicalHistory } from "../../../../api/helper";

const PatientMedicalHistory = () => {
  const [modalVisible, setModalVisible] = useState(false);

  const [medicalData, setMedicalData] = useState({
    head: { trauma: false, migraines: false, concussion: false, skullFracture: false },
    eyes: { blindness: false, cataracts: false, glaucoma: false, wearsGlassesContacts: false, eyeInfection: false },
    ears: { hearingLoss: false, tinnitus: false, earInfections: false, hearingAids: false },
    noseSinuses: { sinusInfection: false, allergicRhinitis: false, nasalFracture: false, nasalPolyps: false },
    mouthThroatTeeth: { gumDisease: false, toothDecay: false, tonsillitis: false, dentures: false },
    cardiovascular: { hypertension: false, angina: false, heartAttack: false, dysrhythmia: false },
    respiratory: { asthma: false, copd: false, pneumonia: false, bronchitis: false },
    neurological: { seizures: false, stroke: false, migraines: false, multipleSclerosis: false },
    musculoskeletal: { arthritis: false, gout: false, fractures: false, muscleStrain: false },
    skin: { psoriasis: false, eczema: false, dermatitis: false, skinCancer: false },
    endocrine: { diabetesType1: false, diabetesType2: false, hypothyroidism: false, hyperthyroidism: false },
    infectiousDiseases: { tuberculosis: false, hiv: false, hepatitisB: false, hepatitisC: false },
    hematologicOncologic: { anemia: false, leukemia: false, lymphoma: false, clottingDisorders: false },
    psychiatric: { anxiety: false, depression: false, bipolarDisorder: false, schizophrenia: false },
    genitourinary: { kidneyStones: false, uti: false, incontinence: false, chronicKidneyDisease: false },
    gastrointestinal: { gerd: false, crohnsDisease: false, ulcerativeColitis: false, irritableBowelSyndrome: false },
    immuneSystem: { autoimmuneDisorders: false, lupus: false, rheumatoidArthritis: false },
  });

  const GetMedicalHistory = async () => {
    const agencyId = "680b1432319b16c8ea4c1dbf";
    const patientId = "681b328d561a4d17220aad65";
    try {
      const response = await FetchMedicalHistory(agencyId, patientId);
      const data = response?.data?.data;
      if (data && Object.keys(data).length > 0) {
        setMedicalData({
          head: data.head || {},
          eyes: data.eyes || {},
          ears: data.ears || {},
          noseSinuses: data.noseSinuses || {},
          mouthThroatTeeth: data.mouthThroatTeeth || {},
          cardiovascular: data.cardiovascular || {},
          respiratory: data.respiratory || {},
          neurological: data.neurological || {},
          musculoskeletal: data.musculoskeletal || {},
          skin: data.skin || {},
          endocrine: data.endocrine || {},
          infectiousDiseases: data.infectiousDiseases || {},
          hematologicOncologic: data.hematologicOncologic || {},
          psychiatric: data.psychiatric || {},
          genitourinary: data.genitourinary || {},
          gastrointestinal: data.gastrointestinal || {},
          immuneSystem: data.immuneSystem || {},
        });
      }
    } catch (error) {
      console.log("Error fetching medical history:", error);
    }
  };

  useEffect(() => {
    GetMedicalHistory();
  }, []);

  // ✅ Handle checkbox change
  const handleCheckboxChange = (category, key, checked) => {
    setMedicalData((prev) => ({
      ...prev,
      [category]: {
        ...prev[category],
        [key]: checked,
      },
    }));
  };

  // ✅ Collect all fields for summary
  const allFields = Object.values(medicalData).flatMap((section) =>
    Object.entries(section)
  );

  const trueFields = allFields.filter(([key, value]) => value === true);
  const falseFields = allFields.filter(([key, value]) => value === false);

  const displayedFields = [
    ...trueFields.slice(0, 5),
    ...falseFields.slice(0, 5 - trueFields.length),
  ];

  const renderMedicalSummary = (key, value) => {
    return (
      <div key={key} className="space_between" style={{ marginTop: 19 }}>
        <div className="smoking_txt1">
          {key.replace(/([A-Z])/g, " $1").toUpperCase()}
        </div>
        <div className="smoking_txt1">{value ? "YES" : "NO"}</div>
      </div>
    );
  };

  return (
    <div className="Lifestyle_Determinants_chart1">
      <div className="Lifestyle_Determinants_div1">
        Medical History
        <div onClick={() => setModalVisible(true)}>
          <img
            src={require("../../../assest/Images/pen_icon.png")}
            alt="Pen Icon"
          />
        </div>
      </div>

      {/* ✅ Summary like LifestyleHistory */}
      {displayedFields.map(([key, value]) => renderMedicalSummary(key, value))}

      {modalVisible && (
        <div className="modal_history" id="modal">
          <div className="modal-content_history">
            <div className="modal-header_history">
              <div className="modal-title flex items-center text-blue-700 font-semibold text-lg mb-2">
                <span className="material-icons mr-2 text-blue-500">🏥</span>
                Medical History
              </div>
              <button
                className="close-btn_history"
                onClick={() => setModalVisible(false)}
              >
                &times;
              </button>
            </div>
            <div className="modal-body_history" id="modal-body">
              {Medicalhistoycategories.map(({ category, label, options }, index) => (
                <div className="category_history" key={index}>
                  <h4>{label}</h4>
                  {Object.entries(options).map(([key, optionLabel], i) => (
                    <div key={i} className="flex flex-col gap-1 mb-2">
                      <label className="flex items-center gap-2">
                        <input
                        disabled
                          type="checkbox"
                          checked={medicalData[category][key] || false}
                          onChange={(e) =>
                            handleCheckboxChange(category, key, e.target.checked)
                          }
                        />
                        {optionLabel}
                      </label>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PatientMedicalHistory;
